import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'test-timer',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(2.5, 3),
      marginBottom: theme.spacing(4),
    },
  }),
  options
);

export default useStyles;
